import React from "react";
import { withTranslation } from "react-i18next";
import "./assets/WaitDialog.css";

const WaitDialog = ({ loading, t }) => {
  if (!loading) return null;

  return (
    <div className="wait-dialog-overlay">
      <div className="wait-dialog-card">
        {/* Custom triple-ring spinner */}
        <div className="wait-dialog-spinner">
          <div className="wait-dialog-spinner-ring" />
          <div className="wait-dialog-spinner-ring" />
          <div className="wait-dialog-spinner-ring" />
          <div className="wait-dialog-spinner-dot" />
        </div>

        {/* Animated loading text */}
        <div className="wait-dialog-text">
          <span>{t("loading")}</span>
          <span className="wait-dialog-dots">
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(WaitDialog);